import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface MachineInstallrequestListState {
    list: any,
  }
  
const initialState:MachineInstallrequestListState = {
    list:undefined,
}

export const machineInstallRequestListSlice = createSlice({
    name:"machineInstallRequestList",
    initialState,
    reducers:{
        UpdateMachineInstallRequestList: (state,action) => {
            state.list = action.payload.machineInstallRequestList;
        },
        AddMachineInstallRequest: (state,action) => {
            state.list = undefined;
        },
        EditMachineInstallRequest: (state,action) => {
            state.list = undefined;
        },
        RemoveMachineInstallRequest: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateMachineInstallRequestList,AddMachineInstallRequest,EditMachineInstallRequest,RemoveMachineInstallRequest} = machineInstallRequestListSlice.actions

export const selectmachineInstallRequestList = (state: RootState) => state.machineInstallRequestList

export default machineInstallRequestListSlice.reducer;